import React, { useState, useEffect } from 'react'
import { CModal, CModalHeader ,CModalTitle , CModalBody, CModalFooter, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CRow, CCol, CFormLabel, CFormInput, CFormTextarea, CFormSelect, CFormCheck, CButton, CTable, CTableHead, CTableHeaderCell, CTableBody, CTableRow, CTableDataCell, CCard, CCardBody } from '@coreui/react'
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'
import DiagnosisDetails from './DiagnosisDetails'
import {  Plus, Trash2 } from 'lucide-react'
import ReasonSuggestion from './ReasonSuggestion'
import CloudinaryUploader from '../../components/shared/CloudinaryUploader'
import { SaveActivity } from './save-activity'


const MedicationDetails = ({ selectMedicationOptions, selectedDiagnoses, allDiagnoses, setSelectedDiagnoses, modalVisible, setSelectedMedicationData, medicationData, setMedicationData, saveMedicationfN, ButtonName, setIsEditing, selectedMedicationData, setModalVisible, classData }) => {
  const [method, setMethod] = useState('')
  const [medicationName, setMedicationName] = useState('')
  const [otherName, setOtherName] = useState('')
  const [maxDose, setMaxDose] = useState('')
  const [therapeutic, setTherapeutic] = useState('')
  const [standingTemplateName, setStandingTemplateName] = useState('')
  const [medicationClass, setMedicationClass] = useState('')
  const [mechanismOfAction, setMechanismOfAction] = useState('')
  const [alerts, setAlerts] = useState('')
  const [sideEffect, setSideEffect] = useState('')
  const [otherRoute, setOtherRoute] = useState('')
  const [specialtyMedication, setSpecialtyMedication] = useState(false)
  const [dosage, setDosage] = useState([])
  const [reason, setReason] = useState([])
  const [drugToDrugIntervations, setDrugToDrugIntervations] = useState([])
  const [medicationOptions, setMedicationOptions] = useState([])
  const [activeTab, setActiveTab] = useState(0)
  const [selectedEditIndexDrug, setSelectedEditIndexDrug] = useState(null)
  const [therapeuticLevels, setTherapeuticLevels] = useState({ min: '', max: '' })
  const [medicationSelectedOption, setMedicationSelectedOption] = useState(null)
  const [selectMedicationClass, setSelectMedicationClass] = useState(null)
  const [medicationImage, setMedicationImage] = useState(null)
  const [file, setFile] = useState([])
  const [selectedMedication, setSelectedMedication] = useState({
    medicationName: '',
    note: '',
  })
 const [reasonEntries, setReasonEntries] = useState([])
  const [codeEntries, setCodeEntries] = useState([])
  const [reasonInput, setReasonInput] = useState('')
  const [codeInput, setCodeInput] = useState('')

  const [diagnosisList, setDiagnosisList] = useState([{ diagnosis: '', reason: '' }])
  const addNewDiagnosis = () => {
    setDiagnosisList((prevList) => [...prevList, { diagnosis: '', reason: '' }])
  }
  const handleDiagnosisChange = (index, selectedDiagnosis) => {
    const updatedList = [...diagnosisList]
    updatedList[index].diagnosis = selectedDiagnosis
    setDiagnosisList(updatedList)
  }


    const addReasonEntry = () => {
      const trimmed = reasonInput.trim()
      if (!trimmed) return
      setReasonEntries((prev) => [...prev, trimmed])
      setReasonInput('')
    }
  
    const addCodeEntry = () => {
      const trimmed = codeInput.trim()
      if (!trimmed) return
      setCodeEntries((prev) => [...prev, trimmed])
      setCodeInput('')
    }

  const handleReasonChange = (index, newReason) => {
    const updatedList = [...diagnosisList]
    updatedList[index].reason = newReason
    setDiagnosisList(updatedList)
  }

  useEffect(() => {
    if (selectedMedicationData) {
      setMedicationName(selectedMedicationData.name || '')
      setMedicationClass(selectedMedicationData.class || '')
      setMechanismOfAction(selectedMedicationData.mechanismOfAction || '')
      setSideEffect(selectedMedicationData.sideEffect || '')
      setMethod(selectedMedicationData.method || '')
      setSpecialtyMedication(Boolean(selectedMedicationData.specialtyMedication))
      setOtherName(selectedMedicationData.otherName || '')
      setMaxDose(selectedMedicationData.maxDose || '')
      setTherapeutic(selectedMedicationData.therapeutic || '')
      setStandingTemplateName(selectedMedicationData.standingTemplateName || '')
      setOtherRoute(selectedMedicationData.otherRoute || '')
      setDosage(selectedMedicationData.dosage || [])
      setAlerts(selectedMedicationData.alerts || '')
      setDrugToDrugIntervations(selectedMedicationData.drugIntervention || [])
      setTherapeuticLevels(selectedMedicationData.therapeuticLevels)
      setReason(selectedMedicationData.reason || [])
      setDiagnosisList(selectedMedicationData.diagnosisList || [{ diagnosis: '', reason: '' }])
      setFile(selectedMedicationData.media || [])
      setMedicationImage(selectedMedicationData.media)
 const parseJsonField = (value) => {
  if (!value) return []

  if (Array.isArray(value)) {
    return value
  }

  try {
    return JSON.parse(value)
  } catch (error) {
    console.error("JSON parse error:", error)
    return []
  }
}


setReasonEntries(
  parseJsonField(selectedMedicationData.MedicationReason)
    .map(x => x.reason || x)
)

setCodeEntries(
  parseJsonField(selectedMedicationData.MedicationCode)
    .map(x => x.code || x)
)
    }
  }, [selectedMedicationData])

  useEffect(() => {
    if (medicationName) {
      const selectedOption = selectMedicationOptions.filter((item) => item?.label === medicationName)
      setMedicationSelectedOption(selectedOption.length > 0 ? selectedOption[0] : null)
    }
    if (medicationClass) {
      const selectClass = classData.filter((item) => item?.label === medicationClass)
      setSelectMedicationClass(selectClass.length > 0 ? selectClass[0] : null)
    }
  }, [medicationName, selectMedicationOptions])

  useEffect(() => {
    setMedicationOptions(medicationData.map((item) => ({ label: item.Data.name, value: item.Data.name })).filter((item) => item.value !== ''))
  }, [medicationData])

  const handleAddMoreDrugIntervation = () => {
    if (selectedEditIndexDrug !== null) {
      const drugListEdited = drugToDrugIntervations.map((item, i) => {
        if (i === selectedEditIndexDrug) {
          return selectedMedication
        }
        return item
      })
      setSelectedEditIndexDrug(null)
      setSelectedMedication({ medicationName: '', note: '' })
      setDrugToDrugIntervations(drugListEdited)
    } else {
      if (!selectedMedication.medicationName || !selectedMedication.note) return
      setDrugToDrugIntervations((prevInterventions) => [...prevInterventions, selectedMedication])
      setSelectedMedication({ medicationName: '', note: '' })
    }
  }

  const handleSelectChange = (selectedOptions) => {
    const selectedLabels = selectedOptions.map((option) => option.label.trim())
    setSelectedDiagnoses(selectedLabels || [])
  }

  const resetForm = () => {
    setMedicationName('')
    setDosage('')
    setMedicationClass('')
    setMechanismOfAction('')
    setSideEffect('')
    setMethod('')
    setTherapeutic('')
    setTherapeuticLevels({ max: '', min: '' })
    setMaxDose('')
    setSelectedDiagnoses([])
    setAlerts('')
    setOtherRoute('')
    setSpecialtyMedication(false)
    setDrugToDrugIntervations([])
    setIsEditing(null)
    setOtherName('')
    setStandingTemplateName('')
    setSelectedMedicationData(null)
    setMedicationSelectedOption(null)
    setSelectedMedication({ medicationName: '', note: '' })
    setReason([])
    setDiagnosisList([{ diagnosis: '', reason: '' }])
    setReasonEntries([])
    setCodeEntries([])
    setReasonInput('')
    setCodeInput('')
    setFile([])
    setMedicationImage(null)
    setSelectMedicationClass(null)
  }

  const handleSave = () => {
    const newDiagnosis =
      Array.isArray(selectedDiagnoses) && selectedDiagnoses.length > 0
        ? typeof selectedDiagnoses[0] === 'object'
          ? selectedDiagnoses
              .filter((label) => label !== undefined)
              .map((diagnosis) => diagnosis.label)
              .join(',')
          : selectedDiagnoses.filter((diagnosis) => diagnosis !== undefined).join(',')
        : ''

    const newMedicationData = {
      medicationName: medicationName,
      medicationClass: selectMedicationClass?.label,
      mechanismOfAction,
      sideEffect,
      method,
      specialtyMedication,
      otherRoute,
      maxDose,
      alerts,
      therapeutic,
      dosage,
      drugIntervention: drugToDrugIntervations,
      otherName,
      standingTemplateName,
      newDiagnosis,
      therapeuticLevels,
      diagnosisList,
      media: file,
      MedicationReason: JSON.stringify(
  reasonEntries.map((reason) => ({
    reason,
  }))
),

MedicationCode: '',
    }
    saveMedicationfN(newMedicationData)
    resetForm()
    SaveActivity('Saved Medication Details')
  }

  const handleEditDrugIntervation = (data, index) => {
    setSelectedEditIndexDrug(index)
    setSelectedMedication({ medicationName: data.medicationName, note: data.note })
  }

  const handleDeleteDrugIntervation = (index) => {
    setDrugToDrugIntervations((prevInterventions) => prevInterventions.filter((_, i) => i !== index))
  }

  const removeReasonEntry = (indexToRemove) => {
    setReasonEntries((prevEntries) => prevEntries.filter((_, index) => index !== indexToRemove))
  }

  const removeCodeEntry = (indexToRemove) => {
    setCodeEntries((prevEntries) => prevEntries.filter((_, index) => index !== indexToRemove))
  }

  const removeDiagnosis = (indexToRemove) => {
    setDiagnosisList((prevDiagnosisList) => prevDiagnosisList.filter((_, index) => index !== indexToRemove))
  }

  const handleDeleteFile = (id) => {
    setFile((prevFiles) => {
      if (prevFiles.length === 1) return []
      return prevFiles.filter((item, i) => item.id !== id)
    })
  }

  const handleCloudinaryUpload = (url, type, fileName, id, publicId) => {
    setFile((prevFiles) => {
      const isDuplicate = prevFiles.some((file) => file.url === url)

      if (isDuplicate) return prevFiles

      return [...prevFiles, { url, type, fileName, id, publicId }]
    })
  }

  return (
    <CModal
      scrollable
      size="lg"
      className="mb-3 p-8 patient-theme-modal medication-theme__modal"
      backdrop="static"
      keyboard={false}
      visible={modalVisible}
      onClose={() => {
        resetForm()
        setModalVisible(false)
      }}
    >
       <CModalHeader onClose={() => setModalVisible(false)}>
        {/* <CModalTitle>{editIndex !== null ? 'Edit Medication' : 'Add Medication'}</CModalTitle> */}
      </CModalHeader>
      <CModalBody className="medication-theme__modal-body" style={{ maxHeight: '75vh', overflow: 'auto' }}>
        <div className="pe-tab-underline-nav mb-4">
          <CNav role="tablist" className="justify-content-center">
            <CNavItem>
              <CNavLink active={activeTab === 0} onClick={() => setActiveTab(0)}>
                Details
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink active={activeTab === 1} onClick={() => setActiveTab(1)}>
                Drug to Drug Interaction
              </CNavLink>
            </CNavItem>
            {/* <CNavItem>
              <CNavLink active={activeTab === 2} onClick={() => setActiveTab(2)}>
                Order
              </CNavLink>
            </CNavItem> */}
            <CNavItem>
              <CNavLink active={activeTab === 3} onClick={() => setActiveTab(3)}>
                Image
              </CNavLink>
            </CNavItem>
          </CNav>
        </div>
        <CTabContent activeTab={activeTab}>
          <CTabPane visible={activeTab === 0}>
            <CRow>
              <CCol md={6}>
                <CFormLabel className="mt-3">Medication Name</CFormLabel>
                <CFormInput type="text" value={medicationName} onChange={(e) => setMedicationName(e.target.value)} />
                {/* <CreatableSelect
                  isClearable
                  value={medicationSelectedOption}
                  onChange={option => { setMedicationSelectedOption(option) }}
                  options={selectMedicationOptions}
                  placeholder='Select or create medication'
                /> */}
              </CCol>

              <CCol md={6}>
                <CFormLabel className="mt-3">Other Name</CFormLabel>
                <CFormInput type="text" value={otherName} onChange={(e) => setOtherName(e.target.value)} />
              </CCol>
              <CCol md={6}>
                <div className="mt-3">
                  <DiagnosisDetails label={'Dosage'} keywords={dosage} setKeywords={setDosage} editMode={true} />
                </div>
                {/* <CFormInput
                  type="text"
                  value={dosage}
                  onChange={e => setDosage(e.target.value)}
                /> */}
              </CCol>
              <CCol md={6}>
                <CFormLabel className="mt-3">Diagnosis</CFormLabel>
                <Select isMulti defaultValue={selectedDiagnoses} onChange={handleSelectChange} options={allDiagnoses} className="basic-multi-select" classNamePrefix="select" closeMenuOnSelect={false} />
              </CCol>

              <CCol md={6}>
                <CFormLabel className="mt-3">Route</CFormLabel>
                <CFormSelect value={method} onChange={(e) => setMethod(e.target.value)}>
                  <option disabled value="">
                    Select Route
                  </option>
                  <option value="PO">PO</option>
                  <option value="IV">IV</option>
                  <option value="Inhale">Inhale</option>
                  <option value="IM">IM</option>
                  <option value="Patch">Patch</option>
                  <option value="Other">Other</option>
                </CFormSelect>

                {method === 'Other' && (
                  <CFormInput
                    placeholder="Enter the custom route"
                    value={otherRoute} // Display the current value of otherRoute
                    onChange={(e) => setOtherRoute(e.target.value)}
                    className="mt-2"
                    type="text"
                  />
                )}
              </CCol>

              <CCol md={6}>
                <div className="d-flex align-items-center" style={{ minHeight: method === 'Other' ? '70px' : '38px', marginTop: method === 'Other' ? '44px' : '46px' }}>
                  <CFormCheck checked={specialtyMedication} onChange={(e) => setSpecialtyMedication(e.target.checked)} label="Specialty Medication" />
                </div>
              </CCol>

<CCol md={12}>
                <hr />
              </CCol>
    {/* Reason */}
<CRow className="mb-3">
  <CCol xs="12">
    <div className="d-flex align-items-end gap-3">
      <div className="flex-grow-1">
        <CFormLabel>Reason</CFormLabel>
        <CFormInput
          type="text"
          placeholder="Enter reason"
          value={reasonInput}
          onChange={(e) => setReasonInput(e.target.value)}
        />
      </div>

        <div
  className="d-flex align-items-center justify-content-center"
  style={{
    width: '42px',
    height: '38px',
    cursor: 'pointer',   
    border: '1px solid #495057',
    borderRadius: '0.375rem',
    background: 'transparent',
  }}
  onClick={addReasonEntry}
>
  <Plus
    className="text-white"
    strokeWidth={2}
    size={24}
  />
</div>
    </div>
  </CCol>
</CRow>

{/* Added Reasons */}
{reasonEntries.length > 0 && (
  <CRow className="mb-3">
    <CCol xs="12">
      <CFormLabel>Added Reasons</CFormLabel>

      <div
        className="form-control d-flex flex-wrap align-items-center gap-2"
        style={{
          minHeight: "48px",
          background: "#1f1f1f",
          borderColor: "#495057",
        }}
      >
        {reasonEntries.map((reason, index) => (
          <span
            key={index}
            className="badge  d-flex align-items-center"            
            style={{
                background:"#2c3e50",
              fontSize: "13px",
              padding: "6px 10px",
            }}
          >
            {reason}

            <button
              type="button"
              className="btn-close btn-close-white ms-2"
              style={{ fontSize: "8px" }}
              onClick={() => removeReasonEntry(index)}
            />
          </span>
        ))}
      </div>
    </CCol>
  </CRow>
)}
{/* Code */}
{/* <CRow className="mb-3">
  <CCol xs="12">
    <div className="d-flex align-items-end gap-3">
      <div className="flex-grow-1">
        <CFormLabel>Code</CFormLabel>
        <CFormInput
          type="text"
          placeholder="Enter code"
          value={codeInput}
          onChange={(e) => setCodeInput(e.target.value)}
        />
      </div>
     <div
  className="d-flex align-items-center justify-content-center"
  style={{
    width: '42px',
    height: '38px',
    cursor: 'pointer',   
    border: '1px solid #495057',
    borderRadius: '0.375rem',
    background: 'transparent',
  }}
  onClick={addCodeEntry}
>
  <Plus
    className="text-white"
    strokeWidth={2}
    size={24}
  />
</div>

      {/* <CButton className="d-flex align-items-center" color="primary" size="sm" onClick={addCodeEntry}>
        +        
      </CButton> */}
    {/* </div>
  </CCol> */}

{/* Added Codes */}
{/* {codeEntries.length > 0 && (
  <CRow className="mb-3">
    <CCol xs="12">
      <CFormLabel>Added Codes</CFormLabel>

      <div
        className="form-control d-flex flex-wrap align-items-center gap-2"
        style={{
          minHeight: "48px",
          background: "#1f1f1f",
          borderColor: "#495057",
        }}
      >
        {codeEntries.map((code, index) => (
          <span
            key={index}
            className="badge  d-flex align-items-center"
            style={{
              background:"#2c3e50",
              fontSize: "13px",
              padding: "6px 10px",
            }}
          >
            {code}

            <button
              type="button"
              className="btn-close btn-close-white ms-2"
              style={{ fontSize: "8px" }}
              onClick={() => removeCodeEntry(index)}
            />
          </span>
        ))}
      </div>
    </CCol>
  </CRow>
)} */}


              {/* <CCol md={12}>
                <CFormLabel className="mt-3">Plan Remark</CFormLabel>
                <CFormTextarea
                  type="text"
                  value={standingTemplateName}
                  onChange={e => setStandingTemplateName(e.target.value)}
                />
              </CCol> */}

              <CCol md={12}>
                <hr />
              </CCol>

              <CCol md={6}>
                <CFormLabel className="mt-3 text-warning">Class</CFormLabel>
                {/* <CFormInput
                  type="text"
                  value={medicationClass}
                  onChange={e => setMedicationClass(e.target.value)}
                /> */}
                <CreatableSelect
                  isClearable
                  value={selectMedicationClass}
                  onChange={(option) => setSelectMedicationClass(option)}
                  options={classData}
                  placeholder="Select or create class"
                  className="basic-single-select ui-react-select medication-theme__select"
                  classNamePrefix="select"
                />
              </CCol>

              <CCol md={6}>
                <CFormLabel className="mt-3 text-warning">Mechanism Of Action</CFormLabel>
                <CFormTextarea value={mechanismOfAction} onChange={(e) => setMechanismOfAction(e.target.value)} rows="3" />
              </CCol>

              <CCol md={12}>
                <CFormLabel className="mt-3 text-warning">Side Effect</CFormLabel>
                <CFormTextarea value={sideEffect} onChange={(e) => setSideEffect(e.target.value)} rows="3" />
              </CCol>

              <CCol md={6}>
                <CFormLabel className="mt-3 text-warning">Max Dose</CFormLabel>
                <CFormInput value={maxDose} onChange={(e) => setMaxDose(e.target.value)} rows="3" />
              </CCol>

              {/* <CCol md={6}>
                <CFormLabel className="mt-3 text-warning">Therapeutic Serum Level</CFormLabel>
                <CFormInput
                  value={therapeutic}
                  onChange={e => setTherapeutic(e.target.value)}
                  rows="3"
                />
              </CCol> */}

              <CCol xs={6}>
                <CFormLabel className="mt-3 text-warning">Therapeutic Serum Level</CFormLabel>
                <CRow className="mt-6">
                  <CCol style={{ marginTop: '4px', position: 'relative' }}>
                    <CFormLabel className="mt-3 text-warning heading-label">Min</CFormLabel>
                    <CFormInput
                      value={therapeuticLevels.min}
                      onChange={(e) => {
                        setTherapeuticLevels((p) => ({
                          ...p,
                          min: e.target.value,
                        }))
                      }}
                      rows="3"
                    />
                  </CCol>
                  <CCol style={{ marginTop: '4px', position: 'relative' }}>
                    <CFormLabel className="mt-3 text-warning heading-label">Max</CFormLabel>
                    <CFormInput
                      value={therapeuticLevels.max}
                      onChange={(e) => {
                        setTherapeuticLevels((p) => ({
                          ...p,
                          max: e.target.value,
                        }))
                      }}
                      rows="3"
                    />
                  </CCol>
                </CRow>
              </CCol>

              <CCol md={12}>
                <CFormLabel className="mt-3 text-warning">Alerts</CFormLabel>
                <CFormTextarea value={alerts} onChange={(e) => setAlerts(e.target.value)} rows="3" />
              </CCol>
            </CRow>
          </CTabPane>

          <CTabPane visible={activeTab === 1}>
            <CRow>
              <CCol md={6}>
                <CFormLabel className="mt-3">Medication Name</CFormLabel>
                <Select
                  options={medicationOptions}
                  isClearable
                  value={medicationOptions.find((option) => option.value === selectedMedication.medicationName) ? medicationOptions.find((option) => option.value === selectedMedication.medicationName) : ''}
                  onChange={(e) =>
                    setSelectedMedication({
                      ...selectedMedication,
                      medicationName: e.value,
                    })
                  }
                  className="basic-single-select ui-react-select medication-theme__select"
                  classNamePrefix="select"
                />
              </CCol>
              <CCol md={6}>
                <CFormLabel className="mt-3">Note</CFormLabel>
                <CFormInput
                  type="text"
                  value={selectedMedication.note}
                  onChange={(e) =>
                    setSelectedMedication({
                      ...selectedMedication,
                      note: e.target.value,
                    })
                  }
                />
              </CCol>

              <CCol>
                <CButton className="mt-3" onClick={handleAddMoreDrugIntervation} color="primary">
                  {selectedEditIndexDrug !== null ? 'Update Drug' : 'Add Drug'}
                </CButton>
              </CCol>

              {drugToDrugIntervations.length > 0 && (
                <CCol md={12}>
                  <CTable>
                    <CTableHead>
                      <CTableRow>
                        <CTableHeaderCell>#</CTableHeaderCell>
                        <CTableHeaderCell>Medication Name</CTableHeaderCell>
                        <CTableHeaderCell>Note</CTableHeaderCell>
                        <CTableHeaderCell>Action</CTableHeaderCell>
                      </CTableRow>
                    </CTableHead>
                    <CTableBody>
                      {drugToDrugIntervations.map((drug, i) => (
                        <CTableRow key={i}>
                          <CTableDataCell>{i + 1}</CTableDataCell>
                          <CTableDataCell>{drug.medicationName}</CTableDataCell>
                          <CTableDataCell>{drug.note}</CTableDataCell>
                          <CTableDataCell>
                            <CButton size="sm" variant="outline" color="warning" onClick={() => handleEditDrugIntervation(drug, i)} className="me-2">
                              Edit
                            </CButton>
                            <CButton size="sm" variant="outline" color="danger" onClick={() => handleDeleteDrugIntervation(i)}>
                              Delete
                            </CButton>
                          </CTableDataCell>
                        </CTableRow>
                      ))}
                    </CTableBody>
                  </CTable>
                </CCol>
              )}
            </CRow>
          </CTabPane>
          <CTabPane visible={activeTab === 2}>
            <CRow>
              <CCol className="d-flex justify-content-center" style={{ marginTop: '-40px' }}>
                <div className="w-75 px-3">
                  <CCard className="" style={{ border: 'none' }}>
                    <CCardBody className="  ">
                      <CButton
                        className=""
                        color="primary"
                        variant="outline"
                        onClick={addNewDiagnosis}
                        // style={{
                        //   backgroundColor: '#f8f9fa',
                        //   borderColor: '#007bff',
                        //   color: '#007bff'
                        // }}
                      >
                        + Add Reason
                      </CButton>
                    </CCardBody>
                  </CCard>

                  <div className="overflow-auto  mx-auto   px-3" style={{ height: '400px', maxWidth: '700px', marginTop: '-30px' }}>
                    {diagnosisList.map((item, index) => (
                      <div
                        key={index}
                        className="p-3 border rounded shadow-sm my-3 position-relative medication-theme__reason-card"
                        style={{
                          borderLeft: '5px solid #007bff',
                          borderRadius: '8px',
                          boxShadow: '0 4px 12px rgba(0, 123, 255, 0.1)',
                        }}
                      >
                        <div className="d-flex justify-content-end align-items-center mb-2">
                          <CButton variant="outline" color="danger" size="sm" onClick={() => removeDiagnosis(index)} className="position-absolute top-0 end-0 m-2" style={{ boxShadow: 'none' }}>
                            <Trash2 size={18} />
                          </CButton>
                        </div>

                        <CFormLabel className="  fw-bold">Select Diagnosis</CFormLabel>
                        <Select
                          isMulti
                          className="basic-multi-select"
                          placeholder="Select Diagnosis"
                          options={allDiagnoses}
                          value={item.diagnosis}
                          onChange={(selectedOption) => handleDiagnosisChange(index, selectedOption)}
                          classNamePrefix="select"
                          styles={{
                            control: (base) => ({
                              ...base,
                              // borderColor: '#007bff',
                              boxShadow: 'none',
                            }),
                          }}
                        />

                        <div className="mt-4">
                          <ReasonSuggestion label={`Reason for Order`} keywords={item?.reason || []} setKeywords={(newReason) => handleReasonChange(index, newReason)} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </CCol>
            </CRow>
          </CTabPane>

          <CTabPane visible={activeTab === 3}>
            <div className="d-flex   gap-2  mt-3 mx-5">
              <CloudinaryUploader filesAl={medicationImage && medicationImage.length > 0 ? medicationImage : file} onDelete={handleDeleteFile} onUploadSuccess={handleCloudinaryUpload} showStyleButton={true} />
              <div className="d-flex flex-wrap gap-3">
                {file.map((file, fileIdx) => {
                  const fileUrl = file.uploaded ? file.url : file.preview || file.url
                  const fileType = file.type || ''
                  const extension = fileUrl.split('.').pop().toLowerCase()

                  return (
                    <div key={fileIdx} className="d-flex flex-column align-items-center text-center">
                      {fileType === 'image' ? (
                        <div
                          style={{
                            position: 'relative',
                            width: '80px',
                            height: '80px',
                            borderRadius: '4px',
                            overflow: 'hidden',
                          }}
                          className="shadow border"
                        >
                          <img
                            src={fileUrl}
                            alt={file.fileName || 'Preview'}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                          />

                          <div
                            style={{
                              position: 'absolute',
                              top: '4px',
                              right: '4px',
                              display: 'flex',
                              gap: '6px',
                              backgroundColor: 'rgba(255, 255, 255, 0.7)',
                              borderRadius: '4px',
                              padding: '2px',
                            }}
                          >
                            {/* <Pencil
                                                     className="cursor-pointer text-primary"
                                                     size={15}
                                                     onClick={() => handleEditFileData(entry.id)}
                                                   />
                            <Trash
                                                     className="cursor-pointer text-danger"
                                                     size={15}
                                                     onClick={() => handleDeleteFileData(entry.id)}
                                                     style ={{cursor: "pointer"}}
                                                   /> */}
                          </div>
                        </div>
                      ) : fileType === 'video' || ['mp4', 'webm', 'ogg'].includes(extension) ? (
                        <div
                          style={{
                            position: 'relative',
                            width: '80px',
                            height: '80px',
                            borderRadius: '4px',
                            overflow: 'hidden',
                            pointer: 'cursor',
                          }}
                          className="shadow border"
                        >
                          {/* Video */}
                          <video
                            src={fileUrl}
                            controls
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                          />

                          {/* Action buttons */}
                          <div
                            style={{
                              position: 'absolute',
                              top: '4px',
                              right: '4px',
                              display: 'flex',
                              gap: '6px',
                              backgroundColor: 'rgba(255, 255, 255, 0.7)',
                              borderRadius: '4px',
                              padding: '2px',
                            }}
                          >
                            {/* <Pencil
                                                       className="cursor-pointer text-primary"
                                                       size={15}
                                                       onClick={() => handleEditFileData(entry.id)}
                                                     />
                            <Trash
                                                       className="cursor-pointer text-danger"
                                                       size={15}
                                                       onClick={() => handleDeleteFileData(entry.id)}
                                                       style={{ cursor: "pointer" }}
                                                     /> */}
                          </div>
                        </div>
                      ) : ['pdf', 'doc', 'docx'].includes(extension) ? (
                        <div
                          style={{
                            position: 'relative',
                            width: '80px',
                            height: '80px',
                            borderRadius: '4px',
                            overflow: 'hidden',
                            background: '#f8f9fa',
                          }}
                          className="d-flex align-items-center justify-content-center border shadow"
                        >
                          {/* File Icon & Extension */}
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              width: '100%',
                              height: '100%',
                              textDecoration: 'none',
                              color: 'inherit',
                            }}
                            className="d-flex align-items-center justify-content-center flex-column"
                          >
                            <i className="bi bi-file-earmark-text" style={{ fontSize: '24px' }}></i>
                            <p className="small m-0">{extension.toUpperCase()}</p>
                          </a>

                          {/* Action buttons */}
                          <div
                            style={{
                              position: 'absolute',
                              top: '4px',
                              right: '4px',
                              display: 'flex',
                              gap: '6px',
                              backgroundColor: 'rgba(255, 255, 255, 0.7)',
                              borderRadius: '4px',
                              padding: '2px',
                            }}
                          >
                            {/* <Pencil
                                                         className="cursor-pointer text-primary"
                                                         size={15}
                                                         onClick={() => handleEditFileData(entry.id)}
                                                       />
                            <Trash
                                                         className="cursor-pointer text-danger"
                                                         size={15}
                                                         onClick={() => handleDeleteFileData(entry.id)}
                                                         style={{ cursor: "delete"}}
                                                       /> */}
                          </div>
                        </div>
                      ) : (
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            width: '100px',
                            height: '100px',
                            borderRadius: '4px',
                            background: '#e0e0e0',
                          }}
                          className="d-flex align-items-center justify-content-center border"
                        >
                          <div>
                            <i className="bi bi-file-earmark" style={{ fontSize: '24px' }}></i>
                            <p className="small m-0">File</p>
                          </div>
                        </a>
                      )}
                      <div
                        style={{
                          width: '100px',
                          height: '20px',
                          overflow: 'auto',
                          marginTop: '5px',
                        }}
                      >
                        <a
                          href={file.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-dark"
                          style={{
                            display: 'inline-block',
                            padding: '2px 5px',
                            backgroundColor: '#f0f0f0',
                            borderRadius: '4px',
                            fontSize: '0.75rem',
                            fontWeight: 'bold',
                            textDecoration: 'none',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                            transition: 'background-color 0.3s ease',
                          }}
                          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')}
                          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#f0f0f0')}
                        >
                          {file.fileName || 'File'}
                        </a>
                      </div>
                      {/* <small className="mt-1 text-truncate" style={{ maxWidth: "100px" }}>
                        {file.fileName}
                      </small> */}
                    </div>
                  )
                })}
              </div>
            </div>
          </CTabPane>
        </CTabContent>
      </CModalBody>

      <CModalFooter className="medication-theme__modal-footer">
        <CButton
          color="secondary"
          className="ui-action-btn ui-action-btn--secondary"
          onClick={() => {
            ;(setModalVisible(false), resetForm())
          }}
        >
          Close
        </CButton>
        <CButton color="primary" className="ui-action-btn ui-action-btn--primary" onClick={handleSave}>
          {ButtonName}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default MedicationDetails
